export default "__VITE_ASSET__BvRAYNUV__"